import { CurrencyInputControlledResult } from '@modules-deprecated/app'

export const currencyInputToString = (amount: CurrencyInputControlledResult): string =>
  `${amount.value} ${amount.currency}`
